import React from 'react';
import { useLocation, Navigate } from 'react-router-dom';

import { useLocalStorage } from 'src/hooks/useLocalStorage';
import NotFound from 'src/modules/not-found';

export const RequireAuth: React.FC<{
  permission: string;
  children: JSX.Element;
}> = ({ children, permission }) => {
  const [modules] = useLocalStorage('modules', []);
  const [token] = useLocalStorage('accessToken', null);
  const location = useLocation();

  if (!token) {
    // Redirect them to the /login page, but save the current location they were
    // trying to go to when they were redirected. This allows us to send them
    // along to that page after they login, which is a nicer user experience
    // than dropping them off on the home page.
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  if (!modules.includes(permission)) {
    return <NotFound name="not-found" />;
  }

  return children;
};
